import { render } from "./StackTraceViewer.vue?vue&type=template&id=22120d80&scoped=true"
import script from "./StackTraceViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./StackTraceViewer.vue?vue&type=script&setup=true&lang=js"

import "./StackTraceViewer.vue?vue&type=style&index=0&id=22120d80&scoped=true&lang=css"

import exportComponent from "/Volumes/Projects/wp_all_repo/wp-content/plugins/debug-log-config-tool/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22120d80"],['__file',"resources/components/StackTraceViewer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22120d80"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22120d80', __exports__)) {
    console.log('reload')
    api.reload('22120d80', __exports__)
  }
  
  module.hot.accept("./StackTraceViewer.vue?vue&type=template&id=22120d80&scoped=true", () => {
    console.log('re-render')
    api.rerender('22120d80', render)
  })

}


export default __exports__